exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".picker__year-display{color:#26a69a !important}\r\n.picker__year{display: none !important}\r\n.add-btn{    position: absolute; right: 30px;     top: 19px;}\r\n.btn{background:#58b392}\r\n.btn:hover{background:#26a69a}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main